import React from "react";
import SEO from "./SEO";

function Services() {
  return (
    <section id="services" className="services" aria-labelledby="services-title">
      <SEO
        title="Cloud & DevOps Services - Sukun"
        description="Explore Sukun’s services: Cloud Consulting (GCP, AWS), Kubernetes, GitOps, performance optimization, and monitoring."
        keywords={["Cloud Services", "DevOps", "Kubernetes", "GitOps", "GCP", "AWS", "Monitoring", "MongoDB", "ClickHouse"]}
      />
      <h2 id="services-title">Cloud & DevOps Services</h2>
      <ul>
        <li>🚀 <strong>Cloud Infrastructure Consulting</strong> (GCP, AWS, Hybrid Kubernetes Cluster [GCP + Bare-metal])</li>
        <li>🛠️ <strong>Kubernetes & GitOps Setup</strong> (Rancher, RKE2, GKE, ArgoCD)</li>
        <li>📈 <strong>Scaling & Performance Optimization</strong> (Redis, Kafka, MongoDB, ClickHouse)</li>
        <li>🔍 <strong>Monitoring & Observability</strong> (DataDog, Prometheus, Grafana)</li>
      </ul>
    </section>
  );
}

export default Services;